import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { theme } from "./theme/theme";
import Layout from "./components/Layout";
import "./i18n";
import { HelmetProvider } from "react-helmet-async";

// Import pages
import Home from "./pages/Home";
import ResearchAndArticles from "./pages/ResearchAndArticles";
import ArticleDetail from "./pages/ArticleDetail";
import SearchPage from "./pages/SearchPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProtectedRoute from "./components/AdminProtectedRoute";

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <HelmetProvider>
          <Routes>
            <Route path="/search" element={<SearchPage />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <AdminProtectedRoute>
                  <AdminDashboard />
                </AdminProtectedRoute>
              }
            />
            <Route
              path="/*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route
                      path="/research-and-articles"
                      element={<ResearchAndArticles />}
                    />
                    <Route
                      path="/research-and-articles/article/:slug"
                      element={<ArticleDetail />}
                    />
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </HelmetProvider>
      </Router>
    </ThemeProvider>
  );
};

export default App;
